import React from 'react'

import { ClassificationResult } from '@documents/types'
import { TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { useStore } from '@frame/lib/stores/useStore'

import { BankRedirectMessage } from '../../bank-redirect-message'
import { useDocumentCardContext } from '../../context'
import { FailureMessage } from '../../failure-message'
import { getMessage } from '../../utils'
import { Classification } from './classification'

type Props = {
  classificationResults?: ClassificationResult[]
}

export function ClassificationFailed({ classificationResults }: Props) {
  const { hideClassification, hasSupportedClassification } = useDocumentCardContext()
  const message = getMessage({ classificationResults })
  const { bankEnabled } = useStrategies()

  const { tasks } = useStore(({ session }) => ({
    tasks: session?.tasks ?? [],
  }))

  const bankTask = tasks.find((task) => task.strategy === TrueworkJsStrategy.BANK)

  const bankDocumentClassified =
    classificationResults?.some((cr) =>
      [
        ClassificationResult.BANK_STATEMENT,
        ClassificationResult.BROKERAGE_STATEMENT,
        ClassificationResult.BANK_ACCOUNT,
      ].includes(cr)
    ) ?? false

  const showBankRedirectMessage = bankEnabled && bankTask && bankDocumentClassified

  return (
    <div className="flex flex-col gap-3">
      {message ? <FailureMessage isUnsupportedType={!hasSupportedClassification}>{message}</FailureMessage> : null}
      {showBankRedirectMessage && <BankRedirectMessage bankTask={bankTask} />}
      {!hideClassification && classificationResults && <Classification classifications={classificationResults} />}
    </div>
  )
}
